var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-raised card-background mt-2 trax-card-with-background",style:('background-image: url('+_vm.backgroundUrl+')')},[_c('div',{class:'card-body '+_vm.alignClass},[_c('div',{staticClass:"w-100"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }